import { render, staticRenderFns } from "./ShenPiNewCaiGouFuKuanEdit.vue?vue&type=template&id=3fa5c59e&scoped=true&"
import script from "./ShenPiNewCaiGouFuKuanEdit.vue?vue&type=script&lang=js&"
export * from "./ShenPiNewCaiGouFuKuanEdit.vue?vue&type=script&lang=js&"
import style0 from "./ShenPiNewCaiGouFuKuanEdit.vue?vue&type=style&index=0&id=3fa5c59e&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3fa5c59e",
  null
  
)

export default component.exports